"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledAlert = void 0;
const material_1 = require("@mui/material");
const styles_1 = require("@mui/material/styles");
exports.StyledAlert = (0, styles_1.styled)(material_1.Alert)(({ theme }) => ({
    margin: theme.spacing(2, 0),
}));
//# sourceMappingURL=styled.js.map